import { render, staticRenderFns } from "./loges.vue?vue&type=template&id=6748112f&"
import script from "./loges.vue?vue&type=script&lang=ts&"
export * from "./loges.vue?vue&type=script&lang=ts&"
import style0 from "./loges.vue?vue&type=style&index=0&id=6748112f&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports